import React from 'react';
import { compose } from 'ramda';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import connect from 'app/libs/connect';
import Text from 'app/components/layout/Text.styled';
import {
  havePlansLoaded,
  productCurrency,
  productPriceAmount,
} from 'app/features/plans/selectors';
import { mappedCouponSku } from 'app/features/couponCampaign/selectors';
import BasicLink from 'app/components/Links/BasicLink.styled';

const legalLink = (text, href, dataT) =>
  href ? (
    <BasicLink href={href} data-t={dataT} target="_blank" rel="noreferrer">
      {text}
    </BasicLink>
  ) : (
    text
  );

const UI = ({ legalText, amount, currency, as, havePlansLoaded }) => (
  <Text size="s" as={as}>
    <FormattedMessage
      id={legalText.textKey}
      values={{
        price: havePlansLoaded && (
          <FormattedNumber
            style="currency"
            currency={currency}
            value={amount}
          />
        ),
        linebreak: <br />,
        termsAndCondsLink: text =>
          legalLink(text, legalText.termsAndCondsLink, 'terms-conds-link'),
        tosLink: text => legalLink(text, legalText.tosLink, 'tos-link'),
        privacyLink: text =>
          legalLink(text, legalText.privacyLink, 'privacy-link'),
      }}
    />
  </Text>
);

UI.propTypes = {
  amount: PropTypes.string,
  currency: PropTypes.string,
  legalText: PropTypes.shape().isRequired,
  havePlansLoaded: PropTypes.bool.isRequired,
  as: PropTypes.oneOfType([PropTypes.symbol, PropTypes.shape()]),
};

UI.defaultProps = {
  amount: '',
  currency: 'USD',
  as: 'p',
};

UI.displayName = 'Legal Text';

const state = {
  havePlansLoaded,
  amount: productPriceAmount,
  currency: productCurrency,
};

const LegalText = compose(
  connect({ sku: mappedCouponSku }),
  connect(state),
)(UI);

export { UI };

export default LegalText;
